import { CypressAttribute } from '@/test-utils/constants/CypressAttribute';

export class TeamCypressAttribute extends CypressAttribute {
  static buttons = {
    ADD_TEAM_MEMBER: 'TeamCypressAttribute:buttons:ADD_TEAM_MEMBER',
    CONTINUE_TO_DASHBOARD: 'TeamCypressAttribute:buttons:CONTINUE_TO_DASHBOARD'
  };

  static inputs = {
    TEAM_NAV_ITEM_DROPDOWN: 'TeamCypressAttribute:inputs:TEAM_NAV_ITEM_DROPDOWN',
    RENAME_TEAM_DROPDOWN: 'TeamCypressAttribute:inputs:RENAME_TEAM_DROPDOWN',
    DELETE_TEAM_DROPDOWN: 'TeamCypressAttribute:inputs:DELETE_TEAM_DROPDOWN',
    ROLE_SELECT: 'TeamCypressAttribute:inputs:ROLE_SELECT',
    TEAM_NAV_ITEM_DROPDOWN_ITEM: 'TeamCypressAttribute:inputs:TEAM_NAV_ITEM_DROPDOWN_ITEM',
    TEAM_NAV_ITEM_DROPDOWN_ITEM_PERSONAL_WORKSPACE:
      'TeamCypressAttribute:inputs:TEAM_NAV_ITEM_DROPDOWN_ITEM_PERSONAL_WORKSPACE'
  };

  static views = {
    TEAM_NAV_ITEM_CURRENT_TEAM_ICON: 'TeamCypressAttribute:views:TEAM_NAV_ITEM_CURRENT_TEAM_ICON',
    TEAM_NAV_ITEM_CURRENT_TEAM: 'TeamCypressAttribute:views:TEAM_NAV_ITEM_CURRENT_TEAM',
    TEAM_NAV_CARET_RIGHT_ICON: 'TeamCypressAttribute:views:TEAM_NAV_CARET_RIGHT_ICON',
    TEAM_TABLE: 'TeamCypressAttribute:views:TEAM_TABLE',
    ROLE_LABEL: 'TeamCypressAttribute:views:ROLE_LABEL'
  };

  static modals: CypressAttribute = {
    inputs: {
      RENAME_TEAM: 'TeamCypressAttribute:models:inputs:RENAME_TEAM',
      CONFIRM_NAME: 'TeamCypressAttribute:models:inputs:CONFIRM_NAME',
      INVITE_MEMBER_EMAIL: 'TeamCypressAttribute:models:inputs:INVITE_MEMBER_EMAIL',
      SET_ADMIN: 'TeamCypressAttribute:models:inputs:SET_ADMIN',
      DELETE_CHOICES: 'TeamCypressAttribute:models:inputs:DELETE_CHOICES'
    },
    buttons: {
      GO_BACK: 'TeamCypressAttribute:models:buttons:GO_BACK',
      DO_THIS_LATER: 'TeamCypressAttribute:models:buttons:DO_THIS_LATER',
      ADD_MEMBER: 'TeamCypressAttribute:models:inputs:ADD_MEMBER',
      REMOVE_MEMBER: 'TeamCypressAttribute:models:inputs:REMOVE_MEMBER'
    },
    views: {}
  };
}
